import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { tokens } from '@companycam/slab-tokens';

import GeneralIcon from './GeneralIcon';

const circleButtonColor = 'transparent';
const circleButtonColorHover = tokens.color_brand_primary;
const circleButtonColorSelected = tokens.color_brand_secondary;

const Container = styled.a`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 2px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: ${(props) =>
    props.selected ? `${circleButtonColorSelected}` : `${circleButtonColor}`};

  :after {
    position: absolute;
    top: 0;
    right: 4px;
    display: block;
    background-color: #3a4b56;
    border-radius: 10px;
    color: white;
    display: none;
    padding: 8px 16px;
    position: absolute;
    font-weight: 600;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
      Helvetica Neue, Arial, sans-serif;
    font-size: 16px;
    line-height: 1;
    z-index: 999;
    content: attr(aria-label);
    transform: translateX(calc(100% + 10px));
    white-space: nowrap;
  }

  :active {
    transform: scale(0.8);
    transition: all ease-in-out 150ms;
  }

  :hover:after {
    display: ${(props) => (props.disabled ? 'none' : 'block')};
  }

  // allows svg icon to have border in sidebar tools
  // ie white selectedncolor needs a border
  ${(props) =>
    !!props.addStroke &&
    `
    svg {
      stroke: rgba(0, 0, 0, 0.35);
      stroke-width: 2;
    }`}

  ${(props) =>
    !!props.selected &&
    `
      svg path {
        fill: white !important;
      }`}

  ${(props) =>
    props.disabled
      ? 'opacity: 0.5;'
      : `:hover {
            background-color: ${circleButtonColorHover};
            transition: 150ms ease-in-out;

            svg path {
              fill: white !important;
            }
          }`}
`;

const IconButton = ({
  selected,
  disabled,
  addStroke,
  label,
  size,
  icon,
  rgb,
  onClick,
}) => (
  <Container
    href="#"
    selected={selected}
    disabled={disabled}
    addStroke={addStroke}
    aria-label={label}
    onClick={(e) => {
      e.preventDefault();
      if (!disabled) {
        onClick();
      }
    }}
  >
    <GeneralIcon size={size} rgb={rgb} icon={icon} />
  </Container>
);

IconButton.propTypes = {
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  addStroke: PropTypes.bool,
  label: PropTypes.string,
  size: PropTypes.number,
  icon: PropTypes.string.isRequired,
  rgb: PropTypes.arrayOf(PropTypes.number),
  onClick: PropTypes.func.isRequired,
};

IconButton.defaultProps = {
  selected: false,
  disabled: false,
  addStroke: false,
  label: '',
  size: 1,
  rgb: [0, 0, 0],
};

export default IconButton;
